import { HealthRatingID } from '../types';

export const health_rating_labels: Record<HealthRatingID, string> = {
  1: 'Indulgent',
  2: 'Average',
  3: 'Healthy',
};
